import type { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw = {
    path: "/app-driver",
    children: [
        {
            path: "app-download",
            name: "driver-app-download",
            component: () => import("@/views/app-driver/index.vue"),
            meta: {
                title: "佬司机",
            },
        },
        {
            path: "/app-driver/qrcode",
            name: "driver-app-qrcode",
            component: () => import("@/views/app-driver/qrcode.vue"),
            meta: {
                title: "佬司机",
            },
        },
        {
            path: "/app-driver/waybill-share-qrcode",
            name: "driver-waybill-share-qrcode",
            component: () => import("@/views/app-driver/waybill-share-qrcode/index.vue"),
            meta: {
                title: "",
            },
        },
        {
            path: "/app-driver/detail",
            name: "driver-app-detail",
            component: () => import("@/views/app-driver/publish/detail.vue"),
            meta: {
                title: "佬司机",
            },
        },
        {
            path: "/app-driver/pre-mall",
            name: "driver-app-pre-mall",
            component: () => import("@/views/app-driver/pre-mall/index.vue"),
            meta: {
                title: "商城预热活动",
            },
        },
        {
            path: "/app-driver/car-captain-apply",
            name: "driver-app-car-captain-apply",
            component: () => import("@/views/app-driver/car-captain-apply.vue"),
            meta: {
                title: "车队长申请活动",
            },
        },
        {
            path: "/app-driver/freight-platform-tax-guide",
            name: "driver-app-freight-platform-tax-guide",
            component: () => import("@/views/app-driver/freight-platform-tax-guide.vue"),
            meta: {
                title: "经营所得个人所得税申报指引",
            },
        },
        {
            path: "/app-driver/partner-recruit",
            name: "driver-app-partner-recruit",
            component: () => import("@/views/app-driver/partner-recruit/index.vue"),
            meta: {
                title: "合伙人招募",
            },
        },
        {
            path: "/app-driver/partner-recruit/questionnaire",
            name: "driver-app-partner-recruit-questionnaire",
            component: () => import("@/views/app-driver/partner-recruit/v2/index.vue"),
            meta: {
                title: "合伙人招募问卷",
            },
        },
        {
            path: "/app-driver/flip-card",
            name: "driver-app-flip-card",
            component: () => import("@/views/app-driver/card-flipping/index.vue"),
            meta: {
                title: "佬司机翻牌活动",
            },
        },
        {
            path: "/app-driver/flip-card-share",
            name: "driver-app-flip-card-share",
            component: () => import("@/views/app-driver/card-flipping/share-index.vue"),
            meta: {
                title: "佬司机翻牌活动",
            },
        },
        {
            path: "/app-driver/flip-card-share-splash",
            name: "driver-app-flip-card-share-splash",
            component: () => import("@/views/app-driver/card-flipping/splash-page.vue"),
            meta: {
                title: "佬司机翻牌活动",
            },
        },
        {
            path: "/app-driver/pre-upgrade/2-0-18",
            name: "driver-app-pre-upgrade-v2.0.18",
            component: () => import("@/views/app-driver/pre-upgrade/index-v2.0.18.vue"),
            meta: {
                title: "佬司机预更新介绍",
            },
        },
        {
            path: "/app-driver/pre-upgrade/2-0-19",
            name: "driver-app-pre-upgrade-v2.0.19",
            component: () => import("@/views/app-driver/pre-upgrade/index-v2.0.19.vue"),
            meta: {
                title: "佬司机预更新介绍",
            },
        },
        {
            path: "/app-driver/pre-upgrade/2-0-20",
            name: "driver-app-pre-upgrade-v2.0.20",
            component: () => import("@/views/app-driver/pre-upgrade/index-v2.0.20.vue"),
            meta: {
                title: "佬司机预更新介绍",
            },
        },
        {
            path: "/app-driver/pre-upgrade/:versionId",
            name: "driver-app-pre-upgrade",
            component: () => import("@/views/app-driver/pre-upgrade/index.vue"),
            props: true,
            meta: {
                title: "佬司机预更新介绍",
            },
        },
        {
            path: "/app-driver/mall/product-share",
            name: "driver-app-mall-product-share",
            component: () => import("@/views/app-driver/mall/share-product.vue"),
            meta: {
                title: "佬司机商城商品分享",
            },
        },
        {
            path: "/app-driver/mall/group-share",
            name: "driver-app-mall-group-share",
            component: () => import("@/views/app-driver/mall/share-group.vue"),
            meta: {
                title: "佬司机拼团",
            },
        },
        {
            path: "/app-driver/mall/open-apply",
            name: "driver-app-mall-open-apply",
            component: () => import("@/views/app-driver/mall/open-apply/index.vue"),
            meta: {
                title: "商城预热活动",
            },
        },
        {
            path: "/app-driver/mall/first-page",
            name: "driver-app-mall-first-page",
            component: () => import("@/views/app-driver/mall/first-page/index.vue"),
            meta: {
                title: "佬司机供应链",
            },
        },
        {
            path: "/app-driver/training-video-share",
            name: "driver-app-training-video-share",
            component: () => import("@/views/app-driver/training-video-share.vue"),
            meta: {
                title: "教学视频",
            },
        },
        {
            path: "/app-driver/activitys/annual-view",
            children: [
                {
                    path: "2025",
                    name: "annual-view-2025",
                    component: () => import("@/views/app-driver/activities/annual-view/2025/index.vue"),
                    meta: {
                        title: "2025年度回顾",
                    },
                },
            ],
        },
        {
            path: "/app-driver/charge-dispatch",
            name: "driver-app-charge-dispatch",
            component: () => import("@/views/app-driver/charge-dispatch/index.vue"),
            meta: {
                title: "新能源车补能调度",
            },
        },
        {
            path: "/app-driver/alipay-promo",
            name: "driver-app-alipay-promo",
            component: () => import("@/views/app-driver/alipay-promo/index.vue"),
            meta: {
                title: "支付宝专属福利",
            },
        },
        {
            path: "/app-driver/:path(.*)*",
            redirect: "/app-driver/app-download",
        },
    ],
};

export default routes;
